import React, { Component } from 'react';
import { connect } from 'react-redux';
import Navigation from '../../components/Navigation/Navigation';
import Loading from '../../components/Loading/Loading';
import { setApplicationSent, setVerificationQuestions, setApplicationAuthUsers } from '../../actions/applicationAction';
import { SetOfferCode } from '../../actions/offerCodeAction';
import { scroller } from 'react-scroll';
import withBackgroundImage from '../../HOC/withBackgroundImage';

import PersonalInfo from './InlineEdit/PersonalInfo';
import Occupation from './InlineEdit/Occupation';
import IncomeExpenses from './InlineEdit/IncomeExpenses';
import Address from './InlineEdit/Address';
import AuthUsers from './InlineEdit/AuthUsers';
import Bpi from './InlineEdit/Bpi';

import OfferCodeField from '../../components/Fields/OfferCodeField';

import { default as CurrentAddress} from './InlineEdit/Address/CurrentAddress';
import { default as MailingAddress} from './InlineEdit/Address/MailingAddress';

import { OfferCodeValidator, PersonalInfoValidator, IncomeExpensesValidator, IncomeFinancesValidator, AddressValidator, MailingAddressValidator, OccupationValidator, AuthUserValidator, BpiValidator } from '../../utils/Validators';

import { INCOMEEXPENSES, INCOMEFINANCES, ADDRESS, MAILINGADDRESS, OCCUPATION, ADDRESS_HOUSINGSTATUS, ADDRESS_MOVEINDATE } from '../../utils/FieldTypes';
import { UpdateFieldsFromSavedState } from '../../utils/UpdateFields';
import { StartApplication } from '../../utils/ApplicationApi';

import debounce from 'debounce';
import { format } from "date-fns";

import './Review.scss';

import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  dataLayer: {
      pageCategory: 'Review',
      event: 'Credit Card Step 6'
  }
}

class Review extends Component {
  constructor(props) {
    super(props);

    this.personalInfoValidator = PersonalInfoValidator();
    this.incomeExpensesValidator = IncomeExpensesValidator();
    this.incomeFinancesValidator = IncomeFinancesValidator();
    this.addressValidator = AddressValidator();
    this.occupationValidator = OccupationValidator(this.props.occupation.status || "");
    this.addressAutocompleteValidation = {
      homeAddress: {
        isInvalid: false,
        message: ""
      }
    };
    this.mailingAddressValidator = MailingAddressValidator();
    this.mailingAddressAutocompleteValidation = {
      homeAddress: {
        isInvalid: false,
        message: ""
      }
    };
    this.authUserValidator = AuthUserValidator();
    this.offerCodeValidator = OfferCodeValidator();
    this.bpiValidator = BpiValidator();

    this.state = {
      sectionsOpen: 0,
      personalInfo: {
        firstName: this.props.personalInfo.firstName || "",
        middleName: this.props.personalInfo.middleName || "",
        lastName: this.props.personalInfo.lastName || "",
        birthdate: this.props.personalInfo.birthdate || "",
        email: this.props.personalInfo.email || "",
        // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
        mobilePhone: this.props.personalInfo.mobilePhone || "",
        homePhone: this.props.personalInfo.homePhone || "",
        accountPassword: this.props.personalInfo.accountPassword || "",
        address: {
          address1: (this.props.personalInfo.address && this.props.personalInfo.address.address1) || "",
          address2: (this.props.personalInfo.address && this.props.personalInfo.address.address2) || "",
          city: (this.props.personalInfo.address && this.props.personalInfo.address.city) || "",
          province: (this.props.personalInfo.address && this.props.personalInfo.address.province) || "",
          postalCode: (this.props.personalInfo.address && this.props.personalInfo.address.postalCode) || ""
        },
        housingStatus: this.props.personalInfo.housingStatus || "",
        moveInDate: this.props.personalInfo.moveInDate || "",
      },
      personalInfoValidation: this.personalInfoValidator.valid(),    
      occupation: {
        status: this.props.occupation.status || "",
        industry: this.props.occupation.industry || "",
        occupationName: this.props.occupation.occupationName || "",
        noc: this.props.occupation.noc || "",
        employer: this.props.occupation.employer || "",
        employedSince: this.props.occupation.employedSince || "",
        phone: this.props.occupation.phone || "",
      },
      occupationValidation: this.occupationValidator.valid(),    
      incomeExpenses: {
        creditcards: this.props.incomeExpenses.creditcards || "",
        income: this.props.incomeExpenses.income || "",
        loans: this.props.incomeExpenses.loans || "",
        rent: this.props.incomeExpenses.rent || "",
        householdincome: this.props.incomeExpenses.householdincome || "",
        investmentincome: this.props.incomeExpenses.investmentincome || "",
      },
      incomeExpensesValidation: this.incomeExpensesValidator.valid(),
      incomeFinancesValidation: this.incomeFinancesValidator.valid(),
      address: {
        address1: (this.props.personalInfo.address && this.props.personalInfo.address.address1) || "",
        address2: (this.props.personalInfo.address && this.props.personalInfo.address.address2) || "",
        city: (this.props.personalInfo.address && this.props.personalInfo.address.city) || "",
        province: (this.props.personalInfo.address && this.props.personalInfo.address.province) || "",
        postalCode: (this.props.personalInfo.address && this.props.personalInfo.address.postalCode) || ""
      },
      addressValidation: this.addressValidator.valid(),
      addressAutocompleteValidation: this.addressAutocompleteValidation,
      mailingAddress: {
        address1: (this.props.personalInfo.mailingAddress && this.props.personalInfo.mailingAddress.address1) || "",
        address2: (this.props.personalInfo.mailingAddress && this.props.personalInfo.mailingAddress.address2) || "",
        city: (this.props.personalInfo.mailingAddress && this.props.personalInfo.mailingAddress.city) || "",
        province: (this.props.personalInfo.mailingAddress && this.props.personalInfo.mailingAddress.province) || "",
        postalCode: (this.props.personalInfo.mailingAddress && this.props.personalInfo.mailingAddress.postalCode) || ""
      },
      mailingAddressValidation: this.mailingAddressValidator.valid(),
      mailingAddressAutocompleteValidation: this.mailingAddressAutocompleteValidation,
      authUsers: this.props.authUsers || [],
      authUserValidations: [...this.props.authUsers.map(authUser => { return(this.authUserValidator.valid());})],
      offerCode: this.props.offerCode || "",
      offerCodeValidations: this.offerCodeValidator.valid(),
      showLoading: false
    };
    this.onClickForward = this.onClickForward.bind(this);
    this.onClickBackward = this.onClickBackward.bind(this);
    this.handlePersonalInfoChange = this.handlePersonalInfoChange.bind(this);
    this.validatePersonalInfoField = this.validatePersonalInfoField.bind(this);
    this.validatePersonalInfoFields = this.validatePersonalInfoFields.bind(this);
    this.updateFieldsFromSavedState = this.updateFieldsFromSavedState.bind(this);

    this.handleChange = this.handleChange.bind(this);
    this.validateField = this.validateField.bind(this);
    this.validateFields = this.validateFields.bind(this);

    this.offerCodeHandleChange = this.offerCodeHandleChange.bind(this);
    this.offerCodeValidateField = this.offerCodeValidateField.bind(this);

    this.populateAddressFields = this.populateAddressFields.bind(this);

    this.getSectionSettings = this.getSectionSettings.bind(this);
    this.setManualEntry = this.setManualEntry.bind(this);
    this.handleAutocompleteChange = this.handleAutocompleteChange.bind(this);
    this.resetAuthUserFieldValidation = this.resetAuthUserFieldValidation.bind(this);
    this.resetAuthUserAddressFieldValidation = this.resetAuthUserAddressFieldValidation.bind(this);
    this.updateAuthUser = this.updateAuthUser.bind(this);
    this.removeAuthUser = this.removeAuthUser.bind(this);
    this.validateAuthUserField = this.validateAuthUserField.bind(this);
    this.updateAuthUserValidation = this.updateAuthUserValidation.bind(this);
    this.countOpenSections = this.countOpenSections.bind(this);
  }
  componentDidMount() {
    document.body.classList.add("white-bg");
    TagManager.dataLayer(tagManagerArgs);
  }
  componentWillUnmount() {
    document.body.classList.remove("white-bg");
  }  
  onClickForward() {
    // Make sure no sections are open for editing before contining to the next screen.
    if(this.state.sectionsOpen === 0 && !this.state.offerCodeValidations.offerCode.isInvalid) {
      this.setState({showLoading: true});
      console.log(this.props)
      StartApplication(this.props.card, this.props.personalInfo, this.props.incomeExpenses, this.props.occupation, this.props.authUsers, this.props.application, this.props.offerCode).then(result => {
        this.setState({showLoading: false});
        this.props.setApplicationSent(true);
        this.props.history.replace('/Review/ConfirmIdentity');
      });
    }
  }
  onClickBackward() {
      this.props.history.replace('/Bpi');
  }
  handlePersonalInfoChange(event) {  
    console.log(event.target.name)
    console.log(event.target.value)  
    if(event.target.type === "date") {
      this.validatePersonalInfoField(event);
      this.setState({
        personalInfo: {...this.state.personalInfo, [event.target.name]: event.target.value}
      });
    }
    else if(event.target.type === "birthdate") {
      this.validatePersonalInfoField(event);
      this.setState({
        personalInfo: {...this.state.personalInfo, [event.target.name]: format(new Date(event.target.value), "yyyy/MM/dd")}
      });
    }    
    else {
      this.setState({
        personalInfoValidation: {...this.state.personalInfoValidation, [event.target.name]: this.personalInfoValidator.resetFieldValidation(event.target.name)},
        personalInfo: {...this.state.personalInfo, [event.target.name]:event.target.value}
      });
    }
  }
  
  validatePersonalInfoField(event) {
    this.setState({
      personalInfoValidation: {...this.state.personalInfoValidation, [event.target.name]: this.personalInfoValidator.validateField(event.target.name, event.target.value)}
    });
  }
  validatePersonalInfoFields(fieldNames, callback) {
    let validatedFields = this.personalInfoValidator.validateFields(fieldNames, this.state.personalInfo);
    this.setState({
      personalInfoValidation: {...this.state.personalInfoValidation, ...validatedFields}
    }, () => {
      callback(this.state.personalInfoValidation.isValid);
    });    
  }

  validateField(type, event) {
    const settings = this.getSectionSettings(type);

    this.setState({
      [settings.validationStateName]: {...settings.validationState, [event.target.name]: settings.validator.validateField(event.target.name, event.target.value)}
    });
  }

  handleChange(type, event) {  
    const settings = this.getSectionSettings(type);
    
    if(event.target.type === "date") {
      this.validateField(type, event);
      this.setState({
        [settings.stateName]: {...settings.state, [event.target.name]:event.target.value}
      });
    }
    if(event.target.type === "birthdate") {
      this.validateField(type, event);
      this.setState({
        [settings.stateName]: {...settings.state, [event.target.name]: format(new Date(event.target.value), "yyyy/MM/dd")}
      });
    }
    else if(event.target.name === "status") {
      // When occupation status is changed, update the validator.
      this.setState({
        [settings.validationStateName]: {...settings.validationState, [event.target.name]: settings.validator.resetFieldValidation(event.target.name)},
        [settings.stateName]: {...settings.state, ...event.target.value}
      }, () => {
        this.occupationValidator = OccupationValidator(this.state[settings.stateName].status);
      });
    }
    else if(event.target.name === "industry") {
      // When the industry is updated, also update occupationName and NOC
      this.setState({
        [settings.validationStateName]: {...settings.validationState, [event.target.name]: settings.validator.resetFieldValidation(event.target.name), occupationName: settings.validator.resetFieldValidation("occupationName")},
        [settings.stateName]: {...settings.state, [event.target.name]:event.target.value, occupationName: "", noc: ""}
      });
    }
    else if(event.target.name === "occupationName") {
      this.setState({
        [settings.validationStateName]: {...settings.validationState, [event.target.name]: settings.validator.resetFieldValidation(event.target.name)},
        [settings.stateName]: {...settings.state, ...event.target.value}
      });
    }
    else {    
      this.setState({
        [settings.validationStateName]: {...settings.validationState, [event.target.name]: settings.validator.resetFieldValidation(event.target.name)},
        [settings.stateName]: {...settings.state, [event.target.name]:event.target.value}
      });
    }
  }
  validateFields(type, fieldNames, callback) {
    const settings = this.getSectionSettings(type);

    let validatedFields = settings.validator.validateFields(fieldNames, settings.state);
    
    this.setState({
      [settings.validationStateName]: {...settings.validationState, ...validatedFields}
    }, () => {
      callback(this.state[settings.validationStateName].isValid);
    });    
  }

  SetOfferCode = debounce(() => {
    this.props.SetOfferCode(this.state.offerCode);
  }, 1000);

  offerCodeHandleChange(event) {
    this.setState({
      offerCodeValidations: {...this.state.offerCodeValidations, [event.target.name]: this.offerCodeValidator.resetFieldValidation(event.target.name)},
      [event.target.name]:event.target.value
    }, () => { 
      this.SetOfferCode();
    });
  }

  offerCodeValidateField(event) {
    console.log(this.state.offerCodeValidations)
    this.setState({
      offerCodeValidations: {...this.state.offerCodeValidations, [event.target.name]: this.offerCodeValidator.validateField(event.target.name, event.target.value)}
    });
  }

  updateFieldsFromSavedState(type, index=0) {    
    this.setState({
      ...UpdateFieldsFromSavedState(this.state, this.props, type, index)
    });
  }
  getSectionSettings(type) {
    switch(type) {
      case (ADDRESS): 
        return ({
          validator: this.addressValidator,
          state: this.state.address,
          stateName: "address",
          validationState: this.state.addressValidation,
          validationStateName: "addressValidation",
        });
      case (MAILINGADDRESS): 
        return ({
          validator: this.mailingAddressValidator,
          state: this.state.mailingAddress,
          stateName: "mailingAddress",
          validationState: this.state.mailingAddressValidation,
          validationStateName: "mailingAddressValidation",
        });
      case (INCOMEEXPENSES): 
        return ({
          validator: this.incomeExpensesValidator,
          state: this.state.incomeExpenses,
          stateName: "incomeExpenses",
          validationState: this.state.incomeExpensesValidation,
          validationStateName: "incomeExpensesValidation",
        });
      case (INCOMEFINANCES):
        return ({
          validator: this.incomeFinancesValidator,
          state: this.state.incomeExpenses,
          stateName: "incomeExpenses",
          validationState: this.state.incomeFinancesValidation,
          validationStateName: "incomeFinancesValidation",
        });
      case (OCCUPATION): 
        return ({
          validator: this.occupationValidator,
          state: this.state.occupation,
          stateName: "occupation",
          validationState: this.state.occupationValidation,
          validationStateName: "occupationValidation",
        });        
      case (ADDRESS_HOUSINGSTATUS): 
      case (ADDRESS_MOVEINDATE):
        return ({
          validator: this.personalInfoValidator,
          state: this.state.personalInfo,
          stateName: "personalInfo",
          validationState: this.state.personalInfoValidation,
          validationStateName: "personalInfoValidation",
        });
      default:
    }  
  }
  populateAddressFields(stateName, addressField) {
    this.setState({
      [stateName]: {...addressField}
    });
  }
  setManualEntry(type, value) {
    // Change manualEntry and reset validation
    switch(type) {
      case (ADDRESS): 
        this.setState({
          address: {...this.state.address, manualEntry: value},
          addressValidation: this.addressValidator.valid(),
          addressAutocompleteValidation: this.addressAutocompleteValidation
        });
        break;
      case (MAILINGADDRESS): 
        this.setState({
          mailingAddress: {...this.state.mailingAddress, manualEntry: value},
          mailingAddressValidation: this.mailingAddressValidator.valid(),
          mailingAddressAutocompleteValidation: this.mailingAddressAutocompleteValidation
        });
        break;
      default:
    }  
  }
  handleAutocompleteChange(type, value) {
    switch(type) {
      case (ADDRESS): 
        this.setState({
          addressAutocompleteValidation: value
        });
        break;
      case (MAILINGADDRESS): 
        this.setState({
          mailingAddressAutocompleteValidation: value
        });
        break;
      default:
    }
  }
  resetAuthUserFieldValidation(event, index) {
    this.setState({
      validations:[...this.state.validations.slice(0, index), 
        {...this.state.validations[index], [event.target.name]: this.authUserValidator.resetFieldValidation(event.target.name)},
        ...this.state.validations.slice(index + 1)]
    });
  }
  resetAuthUserAddressFieldValidation(index) {    
    this.setState({
      authUserValidations:[...this.state.authUserValidations.slice(0, index), 
        {...this.state.authUserValidations[index], 
          address1: this.authUserValidator.resetFieldValidation("address1"),
          address2: this.authUserValidator.resetFieldValidation("address2"),
          city: this.authUserValidator.resetFieldValidation("city"),
          province: this.authUserValidator.resetFieldValidation("province"),
          postalCode: this.authUserValidator.resetFieldValidation("postalCode"),
          homeAddress: {
            isInvalid: false,
            message: ""
          }
        },
        ...this.state.authUserValidations.slice(index + 1)]
      });
  }
  updateAuthUser(authUser, index) {
    this.setState({
      authUsers: [...this.state.authUsers.slice(0, index), authUser, ...this.state.authUsers.slice(index + 1, this.state.authUsers.length)]
    }); 
  }
  removeAuthUser(index) {
    this.setState({
      authUsers:[...this.state.authUsers.slice(0, index), ...this.state.authUsers.slice(index + 1, this.state.authUsers.length)],
      authUserValidations: [...this.state.authUserValidations.slice(0, index), ...this.state.authUserValidations.slice(index + 1, this.state.authUserValidations.length)]
    }, () => {
      this.props.setApplicationAuthUsers(this.state.authUsers.length);
    });
  }
  validateAuthUserField(event, index) {  
    this.setState({
      authUserValidations:[...this.state.authUserValidations.slice(0, index), 
        {...this.state.authUserValidations[index], [event.target.name]: this.authUserValidator.validateField(event.target.name, event.target.value)},
        ...this.state.authUserValidations.slice(index + 1)]
    });
  }
  updateAuthUserValidation(validation, index) {
    this.setState({
      authUserValidations: [...this.state.authUserValidations.slice(0, index), 
        validation,
        ...this.state.authUserValidations.slice(index + 1)]
    });
  }
  countOpenSections(sectionOpen) {
    // Keep track of how many sections are open to prevent user from moving on if there are sections still open.    
    this.setState({
      sectionsOpen: (sectionOpen ? this.state.sectionsOpen + 1 : this.state.sectionsOpen - 1)
    }, () => {
      if(sectionOpen) {
        scroller.scrollTo("inline-edit", {
          duration: 1000,
          smooth: "easeInOutQuad",
          offset: -30
        });
      }
    });
  }
  render() {
    console.log(this.props)
    console.log(this.state.offerCode)
    return (
      <div className="review-application">
        <Loading visible={this.state.showLoading}>
          <div>Your information is being processed. We may have a few questions to verify your identity. This may take up to a few minutes.</div>
          <div>Please do not close or leave this page as your application will not be saved. </div>
        </Loading>
        <h1>Please make sure everything looks ok.</h1>
        <div className={"card-image "+this.props.card.type}><div className="check-mark"></div></div>
        <div><h2>Application for an {this.props.card.name}</h2></div>
        <p className="heading">{this.props.card.benefits}</p>
        <PersonalInfo 
          personalInfo={this.state.personalInfo} 
          validatePersonalInfoFields={this.validatePersonalInfoFields} 
          updateFieldsFromSavedState={this.updateFieldsFromSavedState} 
          validation={this.state.personalInfoValidation} 
          savedPersonalInfo={this.props.personalInfo} 
          handleChange={this.handlePersonalInfoChange} 
          validateField={this.validatePersonalInfoField}
          countOpenSections={this.countOpenSections} 
          sectionsOpen={(this.state.sectionsOpen > 0)}
          />

        <Address
          personalInfo={this.state.personalInfo} 
          savedPersonalInfo={this.props.personalInfo} 
          validation={this.state.personalInfoValidation} 
          handleChange={this.handleChange} 
          validateField={this.validateField} 
          validateFields={this.validateFields} 
          updateFieldsFromSavedState={this.updateFieldsFromSavedState}
          countOpenSections={this.countOpenSections}
          sectionsOpen={(this.state.sectionsOpen > 0)}>
          <CurrentAddress 
            {...this.state.address} 
            savedAddress={this.props.personalInfo.address} 
            handleChange={this.handleChange} 
            populateAddressFields={this.populateAddressFields} 
            validateField={this.validateField} 
            validateFields={this.validateFields}  
            validation={this.state.addressValidation}
            updateFieldsFromSavedState={this.updateFieldsFromSavedState} 
            setManualEntry={this.setManualEntry} 
            autocompleteValidation={this.state.addressAutocompleteValidation} 
            handleAutocompleteChange={this.handleAutocompleteChange}
            countOpenSections={this.countOpenSections}
            sectionsOpen={(this.state.sectionsOpen > 0)} />
          <MailingAddress 
            {...this.state.mailingAddress} 
            savedAddress={this.props.personalInfo.mailingAddress} 
            handleChange={this.handleChange} 
            populateAddressFields={this.populateAddressFields} 
            validateField={this.validateField} 
            validateFields={this.validateFields}  
            validation={this.state.mailingAddressValidation}
            updateFieldsFromSavedState={this.updateFieldsFromSavedState} 
            setManualEntry={this.setManualEntry} 
            autocompleteValidation={this.state.mailingAddressAutocompleteValidation} 
            handleAutocompleteChange={this.handleAutocompleteChange} 
            countOpenSections={this.countOpenSections}
            sectionsOpen={(this.state.sectionsOpen > 0)} /> 
        </Address>
        <Occupation
          occupation={this.state.occupation} 
          savedOccupation={this.props.occupation} 
          validation={this.state.occupationValidation} 
          handleChange={this.handleChange} 
          validateField={this.validateField} 
          validateFields={this.validateFields} 
          updateFieldsFromSavedState={this.updateFieldsFromSavedState}
          countOpenSections={this.countOpenSections}
          sectionsOpen={(this.state.sectionsOpen > 0)} />
        <IncomeExpenses 
          incomeExpenses={this.state.incomeExpenses} 
          savedIncomeExpenses={this.props.incomeExpenses} 
          validation={this.state.incomeExpensesValidation} 
          financeValidation={this.state.incomeFinancesValidation}
          handleChange={this.handleChange} 
          validateField={this.validateField} 
          validateFields={this.validateFields} 
          updateFieldsFromSavedState={this.updateFieldsFromSavedState}
          countOpenSections={this.countOpenSections}
          sectionsOpen={(this.state.sectionsOpen > 0)} />
        <AuthUsers
          authUsers={this.state.authUsers}
          savedAuthUsers={this.props.authUsers}
          removeAuthUser={this.removeAuthUser}
          updateAuthUser={this.updateAuthUser}
          resetAuthUserFieldValidation={this.resetAuthUserFieldValidation}
          validations={this.state.authUserValidations}
          resetAuthUserAddressFieldValidation={this.resetAuthUserAddressFieldValidation}
          validateField={this.validateAuthUserField}
          validator={this.authUserValidator}
          updateValidation={this.updateAuthUserValidation} 
          updateFieldsFromSavedState={this.updateFieldsFromSavedState}
          countOpenSections={this.countOpenSections}
          sectionsOpen={(this.state.sectionsOpen > 0)}
           />
        <Bpi savedBpi = {this.props.application} />
        <OfferCodeField 
          offerCode={this.state.offerCode} 
          hasOfferCode={this.props.hasOfferCode}
          handleChange={this.offerCodeHandleChange} 
          validateField={this.offerCodeValidateField}
          validation={this.state.offerCodeValidations} />
        <Navigation onClickForward={this.onClickForward} onClickBackward={this.onClickBackward} forwardDisabled={(this.state.sectionsOpen > 0) || this.state.offerCodeValidations.offerCode.isInvalid} backwardDisabled={(this.state.sectionsOpen > 0)} />
      </div>);
  }
}

const mapStateToProps = state => ({
  card: state.card,
  personalInfo: state.personalInfo,
  incomeExpenses: state.incomeExpenses,
  occupation: state.occupation,
  authUsers: state.authUsers,
  application: state.application,  
  hasOfferCode: state.offerCode.startedWithOfferCode,
  offerCode: state.offerCode.offerCode 
})

const mapDispatchToProps = dispatch => ({
  setApplicationSent: (applicationSent) => dispatch(setApplicationSent(applicationSent)),
  setVerificationQuestions: (verificationQuestions) => dispatch(setVerificationQuestions(verificationQuestions)),
  setApplicationAuthUsers: (numAuthUsers) => dispatch(setApplicationAuthUsers(numAuthUsers)),
  SetOfferCode: (offerCode) => dispatch(SetOfferCode(offerCode))
})


export default connect(mapStateToProps, mapDispatchToProps)(withBackgroundImage("review")(Review));


// WEBPACK FOOTER //
// ./src/containers/Review/Review.js